<template>
  <div class="contentPadding42" id="ManageTable">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="待办列表" name="first">
        <el-container style="height: 500px; border: 1px solid #eee">
          <el-aside width="200px" style="background-color: rgb(255, 255, 255)">
            <div style="font-size: 14px;height: 40px;line-height: 40px;padding: 0 8px;background-color: #eee;">
              <i class="el-icon-menu"></i> 分类
            </div>
            <el-tree :data="data" :highlight-current="true" :props="defaultProps" @node-click="handleNodeClick">
            </el-tree>
          </el-aside>

          <el-container>
            <el-header height="40px">
              <el-button type="primary" size="mini" icon="el-icon-monitor" @click="toggleSelection()">批量办理</el-button>
              <el-button size="mini" icon="el-icon-monitor">查看</el-button>
              <el-button size="mini" icon="el-icon-refresh">刷新</el-button>
              <el-button size="mini" icon="el-icon-download">导出</el-button>
              <el-button type="text" size="mini" style="float: right;margin-top: 8px;">高级搜索</el-button>
              <div style="width: 240px;float: right;">
                <el-input size="mini" placeholder="请输入标题（关键字）" v-model="input3" class="input-with-select">
                  <el-button size="mini" slot="append" icon="el-icon-search" @click="searchCompany(input3)"></el-button>
                </el-input>
              </div>
            </el-header>

            <el-main>
              <el-table :data="tableData" style="width: 100%"
                :header-cell-style="{'backgroundColor':'rgb(90, 161, 226)','color':'#fff','text-align':'center'}"
                v-loading="loading" @selection-change="handleSelectionChange" ref="multipleTable">
                <!-- <el-table-column align="center" type="index" width="200" label="排序"></el-table-column> -->
                <el-table-column type="selection" width="30">
                </el-table-column>
                <el-table-column prop="name" label="项目标题" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span @click="detail(scope.row)" class="canClick">{{scope.row.name}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="申报企业" show-overflow-tooltip></el-table-column>
                <el-table-column prop="level" label="任务名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="type" label="项目类型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="contacts" label="任务创建时间" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="270">
                  <template slot-scope="scope">
                    <el-button icon="el-icon-edit" size="mini" class="MR18 bg5584FF" type="primary"
                      @click="editGarden(scope.row)">办理
                    </el-button>
                    <el-button icon="el-icon-edit" size="mini" class="MR18 bg5584FF" type="primary"
                      @click="deleteGarden(scope.row)">挂起
                    </el-button>
                    <el-button icon="el-icon-monitor" size="mini" class="MR18 bg5584FF" type="primary"
                      @click="deleteGarden(scope.row)">审核信息
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-main>
          </el-container>
        </el-container>
      </el-tab-pane>
      <el-tab-pane label="已办列表" name="second">
        <el-container style="height: 500px; border: 1px solid #eee">
          <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
            <el-menu :default-openeds="['1', '3']">
              <el-submenu index="1">
                <template slot="title"><i class="el-icon-message"></i>导航一</template>
                <el-menu-item-group>
                  <template slot="title">分组一</template>
                  <el-menu-item index="1-1">选项1</el-menu-item>
                  <el-menu-item index="1-2">选项2</el-menu-item>
                </el-menu-item-group>
                <el-menu-item-group title="分组2">
                  <el-menu-item index="1-3">选项3</el-menu-item>
                </el-menu-item-group>
                <el-submenu index="1-4">
                  <template slot="title">选项4</template>
                  <el-menu-item index="1-4-1">选项4-1</el-menu-item>
                </el-submenu>
              </el-submenu>
              <el-submenu index="2">
                <template slot="title"><i class="el-icon-menu"></i>导航二</template>
                <el-menu-item-group>
                  <template slot="title">分组一</template>
                  <el-menu-item index="2-1">选项1</el-menu-item>
                  <el-menu-item index="2-2">选项2</el-menu-item>
                </el-menu-item-group>
                <el-menu-item-group title="分组2">
                  <el-menu-item index="2-3">选项3</el-menu-item>
                </el-menu-item-group>
                <el-submenu index="2-4">
                  <template slot="title">选项4</template>
                  <el-menu-item index="2-4-1">选项4-1</el-menu-item>
                </el-submenu>
              </el-submenu>
              <el-submenu index="3">
                <template slot="title"><i class="el-icon-setting"></i>导航三</template>
                <el-menu-item-group>
                  <template slot="title">分组一</template>
                  <el-menu-item index="3-1">选项1</el-menu-item>
                  <el-menu-item index="3-2">选项2</el-menu-item>
                </el-menu-item-group>
                <el-menu-item-group title="分组2">
                  <el-menu-item index="3-3">选项3</el-menu-item>
                </el-menu-item-group>
                <el-submenu index="3-4">
                  <template slot="title">选项4</template>
                  <el-menu-item index="3-4-1">选项4-1</el-menu-item>
                </el-submenu>
              </el-submenu>
            </el-menu>
          </el-aside>

          <el-container>
            <el-header style="text-align: right; font-size: 12px">
              <el-dropdown>
                <i class="el-icon-setting" style="margin-right: 15px"></i>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>查看</el-dropdown-item>
                  <el-dropdown-item>新增</el-dropdown-item>
                  <el-dropdown-item>删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <span>王小虎</span>
            </el-header>

            <el-main>
              <el-table :data="tableData">
                <el-table-column prop="date" label="日期" width="140">
                </el-table-column>
                <el-table-column prop="name" label="姓名" width="120">
                </el-table-column>
                <el-table-column prop="address" label="地址">
                </el-table-column>
              </el-table>
            </el-main>
          </el-container>
        </el-container>
      </el-tab-pane>
      <el-tab-pane label="完结列表" name="third">完结列表</el-tab-pane>
      <el-tab-pane label="终结列表" name="fourth">终结列表</el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  export default {
    data() {
      const item = {
        date: '2016-05-02',
        name: '王小虎adfafaf adfa adf adf',
        address: '上海市普陀区金沙江路 1518 弄'
      };
      return {
        activeName: 'first',
        tableData: [{
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-08',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-06',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-07',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }],
        data: [{
          label: '一级 1',
          children: [{
            label: '二级 1-1',
            children: [{
              label: '三级 1-1-1'
            }]
          }]
        }, {
          label: '一级 2',
          children: [{
            label: '二级 2-1',
            children: [{
              label: '三级 2-1-1'
            }]
          }, {
            label: '二级 2-2',
            children: [{
              label: '三级 2-2-1'
            }]
          }]
        }, {
          label: '一级 3',
          children: [{
            label: '二级 3-1',
            children: [{
              label: '三级 3-1-1'
            }]
          }, {
            label: '二级 3-2',
            children: [{
              label: '三级 3-2-1'
            }]
          }]
        }],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        input3: '',
        multipleSelection: []
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
      handleNodeClick(data) {
        console.log(data);
      },
      searchCompany(val) {
        console.log(val)
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      toggleSelection(rows) {
        console.log(this.multipleSelection)
        if (this.multipleSelection.length == 0) {
          this.$alert('<div style="line-height:30px"><i class="el-icon-warning-outline" style="font-size:30px;color:rgba(90, 161, 226);margin-right:5px;float:left"></i>请选择批量办理的项目</div>', '提示', {
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: true
            // callback: action => {
            //   this.$message({
            //     type: 'info',
            //     message: `action: ${action}`
            //   });
            // }
          });
        } else if (this.multipleSelection.length == 1) {
          this.$alert('<div style="line-height:30px"><i class="el-icon-warning-outline" style="font-size:30px;color:rgba(90, 161, 226);margin-right:5px;float:left"></i>单个项目请直接点击办理</div>', '提示', {
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: true
            // callback: action => {
            //   this.$message({
            //     type: 'info',
            //     message: `action: ${action}`
            //   });
            // }
          });
        }
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
    }
  };
</script>

<style>
  .el-header {
    background-color: #fff;
    color: #333;
    line-height: 40px;
  }

  .el-aside {
    color: #333;
    border-right: 1px solid #eee;
  }

  .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: rgb(90, 161, 226);
    color: #fff;
  }

  .el-button+.el-button {
    /* float: left; */
    margin-left: 0;
  }

  .MR18 {
    margin-right: 2PX !important;
  }
</style>